<template>
  <div class="container">
    <div class="frame">
      <div class="frame__inner">
        <div class="frame__header">
          <Back
            :redirect="redirect"
            title="На банковскую карту"
          />
        </div>
        <div class="frame__body">
          <div class="card-remittances">
            <div class="card-remittances__inner">
              <div class="card-remittances-warning card-remittances__warning">
                <div class="card-remittances-warning__inner">
                  <div class="card-remittances-warning__icon">
                    <img
                      src="@/assets/icons/attentionBlack.svg"
                      alt="icon"
                    >
                  </div>
                  <div class="card-remittances-warning__text">
                    Cредства, списанные с баланса, будут возвращены 
                    <span>в течение 30 минут</span>, если вы не укажете номер карты.
                  </div>
                </div>
              </div>
              <div class="card-remittances__info">
                <span class="card-remittances__info-label label">Откуда:</span>
                <span>+7 {{ paymentInfo.phone }}</span>
              </div>
              <div class="card-remittances__form">
                <div
                  id="iframe"
                  ref="iframe"
                  class="card-remittances__iframe"
                />
              </div>
              <div class="card-remittamces__btn">
                <ap-button
                  type="primary"
                  full
                  @click="goMain"
                >
                  Вернуться на главную
                </ap-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';


import apButton from '@/components/UI/apButton.vue';
import Back from '@/components/Back.vue';

export default defineComponent({
  name: 'CardRemittances',
  components: {
    Back,
    apButton
  },
  
  setup() {
    const iframe = ref();
    const route = useRoute();
    const router = useRouter();
    const { t } = useI18n();

    const redirect = ref({
      name: 'main',
      text: t('main') 
    });

    const paymentInfo = ref({
      phone: route.params.phone,
    });

    const prepareFrame = (url) => {
      const container = document.getElementById('iframe');
      let ifrm = document.createElement('iframe');
      ifrm.setAttribute('src', url);
      ifrm.style.width = '100%';
      ifrm.style.height = '100%';
      ifrm.style.minHeight = '280px';
      ifrm.style.border = 'none';
      container?.appendChild(ifrm);
    };

    const goMain = () => {
      router.push({ name: 'main' });
    };

    onMounted(() => {
      if (route.params && route.params.url) {
        prepareFrame(route.params.url);
      }
    });

    return {
      paymentInfo,
      redirect,
      iframe,
      goMain
    };    
  },
});
</script>
<style lang="scss" scoped>
.card-remittances{
  padding: 34px 16px 48px 16px;
  &__inner{
    max-width: 350px;
    width: 100%;
    margin: 0 auto;

  }
  &__warning{
    margin-bottom: 21px;
  }
  &__form-label{
    margin-bottom: 10px;
  }
  &__info{
    margin-bottom: 35px;
    display: flex;
    justify-content: space-between;
  }
  &__iframe{
    height: 550px;
  }
}
.label{
  color: $primary-gray;
  font-weight: 400;
  font-size: 13px;
  line-height: 21px;
}
.card-remittances-warning{
  padding: 8px;
  background: rgba(166, 207, 255, 0.15);
  border: 1px solid rgba(173, 180, 184, 0.5);
  border-radius: 4px;
  &__inner{
    display: flex;
  }
  &__icon{
    margin-right: 7px;
  }
  &__text{
    font-weight: 400;
    font-size: 12px;  
    line-height: 16px;
    letter-spacing: 0.001em;
    span{
      color: $primary-purple;
    }
  }
}
.tele2{
  .card-remittances-warning{
    &__text{
      span{
        color: $secondary-blue;
      }
    }
  }
}
.altel{
  .card-remittances-warning{
    &__text{
      span{
        color: $primary-pink;
      }
    }
  }
}
</style>